import type { ComplianceForms } from '../../../generated/graphql-viewer';

import { useTranslation } from 'react-i18next';
import { useSelectedLanguage } from 'src/viewer/providers/selected-language-provider';

import { RichTextContent } from '../../../components/rich-text';
import { isRichTextEditorContentEmpty } from '../../../utils';

import styles from './compliance-links.module.css';

type Props = {
  complianceForms?: ComplianceForms | null;
};

export function ComplianceLinks({ complianceForms }: Props) {
  const { t } = useTranslation();
  const { selectedLanguage } = useSelectedLanguage();

  if (!complianceForms) return;

  const includeDefaultComplianceForm = complianceForms.includeDefaultComplianceForm;
  const customLinks = complianceForms.customComplianceForm?.entries.find(
    ({ language }) => language === selectedLanguage?.code
  );
  const fallbackCustomLink = complianceForms.customComplianceForm?.entries.find(({ language }) => language === 'en');
  const defaultLinks = complianceForms.defaultComplianceForm?.entries.find(
    ({ language }) => language === selectedLanguage?.code
  );
  const fallbackDefaultLinks = complianceForms.defaultComplianceForm?.entries.find(({ language }) => language === 'en');

  const customLinksText = customLinks?.text || fallbackCustomLink?.text || '';
  const defaultLinksText = defaultLinks?.text || fallbackDefaultLinks?.text || '';

  return (
    <div>
      {!isRichTextEditorContentEmpty(customLinksText) && (
        <RichTextContent data-testid="custom-compliance-links" value={customLinksText} />
      )}

      {includeDefaultComplianceForm && !isRichTextEditorContentEmpty(defaultLinksText) && (
        <RichTextContent data-testid="default-compliance-links" value={defaultLinksText} />
      )}

      {includeDefaultComplianceForm && (
        <div className={styles.miComplianceLinksWrapper}>
          <a
            href={t('viewer.views.stream.complianceLinks.imprintUrl')}
            rel="noopener noreferrer"
            target="_blank"
            data-testid="mi-imprint-link"
          >
            {t('viewer.views.stream.complianceLinks.imprint')}
          </a>

          <a
            href={t('viewer.views.stream.complianceLinks.privacyPolicyUrl')}
            rel="noopener noreferrer"
            target="_blank"
            data-testid="mi-privacy-policy-link"
          >
            {t('viewer.views.stream.complianceLinks.privacyPolicy')}
          </a>
        </div>
      )}
    </div>
  );
}
